// extracted by mini-css-extract-plugin
module.exports = {"container":"_32bbee5fda--container--OVAUT","link":"_32bbee5fda--link--PsRym","icon":"_32bbee5fda--icon--mLUKb"};